import React from 'react';
import * as mobxReact from 'mobx-react';
import { IntlShape, useIntl } from 'react-intl';
import { CommonPopupBodyFooterLayout } from '../../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../../global/sub-window/common/common-close-sub-window-buttons';
import { SCHEDULED_EMAILS_DATA_LOADING_TEXT } from './scheduled-emails-form.texts';
import { CANCEL_TEXT, DONE_TEXT } from '../../../../../../constants/common-labels.constants';
import { ScheduledEmailsFormSection } from './_scheduled-email-form-section/scheduled-emails-form-section-presentation';
import { ScheduledEmailsFormManagement } from './scheduled-emails-form-management.viewmodel';

interface IProps {
    intl: IntlShape;
    vm: ScheduledEmailsFormManagement;
}

const ScheduledEmailsFormPresentation = mobxReact.observer((props: IProps) => {
    const { vm } = props;
    const intl = useIntl();

    if (vm.isLoading) {
        return <CommonPopupBodyFooterLayout
            body={
                <div className='oe-form'>
                    {intl.formatMessage(SCHEDULED_EMAILS_DATA_LOADING_TEXT)}
                </div>
            } />;
    }

    return (
        <>
            <CommonPopupBodyFooterLayout
                className='oe-form'
                body={
                    <div className='scheduled-emails-form oe-form-body'>
                        <ScheduledEmailsFormSection vm={vm} />
                    </div>
                }
                footer={
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultCloseSubWindowButton
                            text={intl.formatMessage(DONE_TEXT)}
                            modifier={['fat', 'confirm-safe']}
                            onClick={() => true}
                        />
                        <DefaultCloseSubWindowButton
                            text={intl.formatMessage(CANCEL_TEXT)}
                        />
                    </div>
                }
            />
        </>
    );
});

export { ScheduledEmailsFormPresentation };
